import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map } from 'rxjs';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return authService.isLoggedIn().pipe(
    map((authResponse) => {
      if (authResponse.isLoggedIn) return true;

      return router.parseUrl('/login');
    }),
  );
};
